<script>
import { mapState } from "vuex";
import JobTechnicianMessageWindow from "../../windows/JobTechnicianMessage";

export default {
  props: {
    jobId: {
      type: Number,
      required: true,
    },
    jobData: {
      type: Object,
    },
    loadJobFromApi: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // this.addButtonInHeader();
  },
  computed: {
    ...mapState({
      job: function (state) {
        return state.jobs.stacks.current.length
          ? state.jobs.stacks.current[0]
          : null;
      },
    }),
    currentWorkableDate() {
      if (!this.job) {
        return null;
      }

      // search for closest date of all dates which is today and has status planned or in process
      // in fact the status of the dates should always be 'planned' or 'inprocess' if the job status itself is 'planned' or 'inprocess', this is just an additional check for being on the safe side..
      const now = new Date().getTime();
      const datesToday = this.job.dates
        //.filter(date => date.isToday)
        //.filter(date => date.status == this.app.options.JobDate.STATUS.planned || date.status == this.app.options.JobDate.STATUS.inprocess)
        .sort((a, b) => {
          return Math.abs(a.startDate.getTime() - now) <
            Math.abs(b.startDate.getTime() - now)
            ? -1
            : 1;
        });

      return datesToday.length ? datesToday[0] : null;
    },
    jobWorkable() {
      // technician can start working on this job if the job status is 'planned' or 'inprocess' and there is a current workable date and all fittings have status 1 or 2 (if not already in process)
      return (
        this.job &&
        (this.job.status == this.app.options.Job.STATUS.planned ||
          this.job.status == this.app.options.Job.STATUS.inprocess) &&
        this.currentWorkableDate != null &&
        (this.job.status == this.app.options.Job.STATUS.inprocess ||
          this.fittingsChecked)
      );
    },
    checkableFittings() {
      if (!this.job) {
        return [];
      }

      return this.job.parts.reduce((fittings, part) => {
        return fittings.concat(
          part.fittings.filter((fitting) => fitting.category == 2)
        );
      }, []);
    },
    fittingsChecked() {
      return (
        this.checkableFittings.length == 0 ||
        this.checkableFittings.every(
          (fitting) => fitting.status == 1 || fitting.status == 2
        )
      );
    },
    fittingsCheckable() {
      return this.job && this.job.status == this.app.options.Job.STATUS.planned;
    },
  },
  watch: {
    $route(to, from) {
      this.addButtonInHeader();
    },
    job: {
      immediate: true,
      handler: function (newJob) {
        if (newJob) {
          if (this.$route.meta) {
            this.$route.meta.title =
              newJob.type == this.app.options.Job.TYPE.servicing
                ? "Service"
                : "Montage";
            // Add a temporary query parameter.
            this.$router.replace({
              query: {
                temp: Date.now(),
                partID:
                  this.$route.query && this.$route.query.partID
                    ? this.$route.query.partID
                    : undefined,
              },
            });

            // Remove the temporary query parameter.
            this.$router.replace({
              query: {
                temp: undefined,
                partID:
                  this.$route.query && this.$route.query.partID
                    ? this.$route.query.partID
                    : undefined,
              },
            });
          }
        }
        /*if(!this.jobData) {
                    if(newJob && this.jobId != newJob.id) {
                        this.$router.push({ name: 'Job', params: { jobId: this.job.id, jobData: this.job } })
                    }else if(!this.currentWorkableDate) {
                        this.$router.push({ name: 'Dashboard' });
                    }
                }*/
      },
    },
  },
  async created() {
    if (this.jobData) {
      // if job data is given, just set the stack (temporary), so there is no loading time
      this.$store.dispatch("jobs/setStackAndCommit", {
        stack: "current",
        items: [this.jobData],
      });
    }

    if (this.loadJobFromApi) {
      // if set, always try to load the job from the api, so we make sure the job data will be up to date if we are online
      this.jobDataLoading = this.$store.dispatch("jobs/loadSingle", {
        id: this.jobId,
        sources: ["api"],
        targetStack: "current",
      });

      if (!this.jobData) {
        this.app.isLoading = true;
        await this.jobDataLoading;
        this.app.isLoading = false;
      }
    } else if (!this.job && !this.jobData) {
      // otherwise try to load from stacks and indexeddb only if there is no job set
      this.$store.dispatch("jobs/loadSingle", {
        id: this.jobId,
        sources: ["stacks", "db"],
        targetStack: "current",
      });
    }
  },
  methods: {
    addButtonInHeader() {
      if (this.job && this.job.status < this.app.options.Job.STATUS.finished) {
        this.app.layout.addButton({
          icon: "note.svg",
          handler: async ($triggerEvent = null) => {
            const message = await this.$windows.showWindow(
              JobTechnicianMessageWindow,
              {
                title:
                  this.__(`jobs.common.types.${this.job.typeName}`) +
                  ` ${this.job.id_extern}`,
              },
              $triggerEvent ? $triggerEvent.target : null
            );

            if (message) {
              if (navigator.onLine) {
                this.app.isLoading = true;
              }
              await this.$store.dispatch("jobs/sendCommonTechnicianMessage", {
                id: this.job.id,
                message,
              });
              this.app.isLoading = false;
            }
          },
        });
      }
    },
  },
};
</script>